<template>
  <div class="img" :class="size" :style="{ backgroundImage, backgroundColor }">
    <span v-if="!image">{{altName}}</span>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: [
    'image',
    'name',
    'size'
  ],
  computed: {
    backgroundImage()  {
      return this.image && `url('${this.image}')`;
    },
    backgroundColor() {
      return this.name && `#${this.intToRGB(this.hashCode(this.name))}` || '';
    },
    altName() {
      return (this.name || '')
        .split(' ')
        .slice(0, 2)
        .map((part) => part.substring(0,1))
        .join('')
        .toUpperCase();
    }
  },
  methods: {
    hashCode(str) {
      let hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    },
    intToRGB(i) {
      let c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    }
  }
}
</script>

<style scoped lang="scss">
.img {
  display: block;
  min-width: 33px;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: rgba(0,0,0,0.2);
  background-size: 100% 100%;
  background-position: center;
  text-align: center;

  span {
    color: #fff;
    font-size: 13px;
    line-height: 33px;
    text-transform: capitalize;
  }

  &.large {
    min-width: 66px;
    width: 66px;
    height: 66px;

    span {
      font-size: 26px;
      line-height: 66px;
    }
  }
}
</style>
